import * as defaultImport from "@splunk/visualizations/SingleValue";
export * from "@splunk/visualizations/SingleValue";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
